import axios from 'axios';
import { ROOT_URL, getAuthHeaders, isUnauthorizedError } from './constants';

// Constantes para el manejo de permisos de Power BI en el estado

// Trae todos los permisos de power bi
export const GET_POWER_BI_ACCESSES = 'GET_POWER_BI_ACCESSES';

// Trae un permiso específico por id
export const GET_POWER_BI_ACCESS = 'GET_POWER_BI_ACCESS';

// Crea un nuevo permiso
export const CREATE_POWER_BI_ACCESS = 'CREATE_POWER_BI_ACCESS';

// Actualiza un permiso existente
export const UPDATE_POWER_BI_ACCESS = 'UPDATE_POWER_BI_ACCESS';

// Deshabilita un permiso
export const DISABLE_POWER_BI_ACCESS = 'DISABLE_POWER_BI_ACCESS';

// Habilita un permiso
export const ENABLE_POWER_BI_ACCESS = 'ENABLE_POWER_BI_ACCESS';

// Obtiene los tipos de acceso disponibles
export const GET_ACCESS_TYPES = 'GET_ACCESS_TYPES';

// Obtiene los programas de Banner
export const GET_BANNER_PROGRAMS = 'GET_BANNER_PROGRAMS';

// Obtiene las facultades de Banner
export const GET_BANNER_FACULTIES = 'GET_BANNER_FACULTIES';

// Obtiene los departamentos de Banner
export const GET_BANNER_DEPARTMENTS = 'GET_BANNER_DEPARTMENTS';

/**
 * Obtiene los permisos de Power BI de la aplicación.
 *
 * @export getPowerBiAccesses
 * @param pagination : Opciones de paginación (opcional).
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function getPowerBiAccesses(pagination = '', successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.get(`${ROOT_URL}/power_bi_accesses${pagination}`, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: GET_POWER_BI_ACCESSES,
        payload: data
      });
      successCallback();
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

/**
 * Obtiene un permiso específico por ID.
 *
 * @export getPowerBiAccess
 * @param {*} id : El id del permiso.
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function getPowerBiAccess(id, successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.get(`${ROOT_URL}/power_bi_accesses/${id}`, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: GET_POWER_BI_ACCESS,
        payload: data
      });
      successCallback();
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

/**
 * Crea un nuevo permiso de Power BI.
 *
 * @export createPowerBiAccess
 * @param {*} powerBiAccessData : Datos del permiso a crear.
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function createPowerBiAccess(powerBiAccessData, successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.post(`${ROOT_URL}/power_bi_accesses`, {
    power_bi_access: powerBiAccessData
  }, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: CREATE_POWER_BI_ACCESS,
        payload: data
      });
      successCallback(data);
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

/**
 * Actualiza un permiso de Power BI existente.
 *
 * @export updatePowerBiAccess
 * @param {*} id : El id del permiso.
 * @param {*} powerBiAccessData : Datos del permiso a actualizar.
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function updatePowerBiAccess(id, powerBiAccessData, successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.patch(`${ROOT_URL}/power_bi_accesses/${id}`, {
    power_bi_access: powerBiAccessData
  }, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: UPDATE_POWER_BI_ACCESS,
        payload: data
      });
      successCallback(data);
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

/**
 * Elimina (deshabilita) un permiso de Power BI.
 *
 * @export disablePowerBiAccess
 * @param {*} id : El id del permiso.
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function disablePowerBiAccess(id, successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.patch(`${ROOT_URL}/power_bi_accesses/${id}/disable`, {}, getAuthHeaders());

  return (dispatch) => {
    request.then(() => {
      dispatch({
        type: DISABLE_POWER_BI_ACCESS,
        payload: id
      });
      successCallback();
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

/**
 * Habilita un permiso de Power BI previamente deshabilitado.
 *
 * @export enablePowerBiAccess
 * @param {*} id : El id del permiso.
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function enablePowerBiAccess(id, successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.patch(`${ROOT_URL}/power_bi_accesses/${id}/enable`, {}, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: ENABLE_POWER_BI_ACCESS,
        payload: data
      });
      successCallback(data);
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

/**
 * Obtiene los tipos de acceso disponibles.
 *
 * @export getAccessTypes
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function getAccessTypes(successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.get(`${ROOT_URL}/access_types`, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: GET_ACCESS_TYPES,
        payload: data
      });
      successCallback(data);
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

/**
 * Obtiene los programas de Banner disponibles.
 *
 * @export getBannerPrograms
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function getBannerPrograms(successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.get(`${ROOT_URL}/banner_programs`, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: GET_BANNER_PROGRAMS,
        payload: data
      });
      successCallback(data);
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

/**
 * Obtiene las facultades de Banner disponibles.
 *
 * @export getBannerFaculties
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function getBannerFaculties(successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.get(`${ROOT_URL}/banner_faculties`, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: GET_BANNER_FACULTIES,
        payload: data
      });
      successCallback(data);
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

/**
 * Obtiene los departamentos de Banner disponibles.
 *
 * @export getBannerDepartments
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function getBannerDepartments(successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.get(`${ROOT_URL}/banner_departments`, getAuthHeaders());

  return (dispatch) => {
    request.then(({data}) => {
      dispatch({
        type: GET_BANNER_DEPARTMENTS,
        payload: data
      });
      successCallback(data);
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  }
}

